// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/login',
};

export const PATH_PRIVATE = {
  Home: '/',
  GetToken: '/getToken',
  SendRemittance: '/send-remittance',
  CancelRemittance: '/cancel-remittance',
  GetReadyTransactions: '/get-ready-transactions',
  GetTransactionDetails: '/get-transaction-details',
  GetCountries: '/get-countries',
  GetEntities: '/get-entities',
  GetAgents: '/get-agents',
  GetBalance: '/get-balance',
  ValidateAccount: '/validate-account',
  UpdateBeneficiaryDetails: '/update-beneficiary-details',
  GetExchangeRates: '/get-exchange-rates',
  GetCountryServices: '/get-country-services',
  GetBanksByCountry: '/get-banks-by-country',
  ErrorCodes: '/error-codes',
  Appendix: "/appendix"
};

export const PATH_SETTINGS = {
  Root: '/settings',
  DahabCredentials: '/settings/dahab-credentials',
  WhitelistIPs: '/settings/whitelist-ips'
};

export const END_POINTS_PATH ={
  LogIn: '/accounts/logIn',
  GetToken: '/accounts/getToken',
  Verify2FA: '/accounts/verify2fa',
  SendRemittance: '/Remittances/SendRemittance',
  CancelRemittance: '/Remittances/CancelTransaction',
  GetReadyTransactions: '/Remittances/GetReadyTransactions',
  GetTransactionDetails: '/Remittances/GetTransactionDetail',
  GetCountries: '/Common/GetCountries',
  GetEntities: '/Common/GetEntities',
  GetExchangeRates: '/Remittances/GetExchangeRates',
  GetAgents: '/Common/GetAgentByCountry',
  GetBalance: '/Remittances/GetBalance',
  ValidateAccount: '/Remittances/ValidateAccount',
  UpdateBeneficiaryDetails: '/Remittances/UpdateBeneficiaryDetails',
  GetCountryServices: '/Common/GetCountryServices',
  GetBanksByCountry: '/Common/GetBanksByCountry',
  APICredentials: '/APICredentials',
  IPWhitelist: '/IPWhitelist'
}